import Button from "ds/components/Button";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import useUnlockTofuWorkspace from "shared/Stack/useUnlockTofuWorkspace";
import { TofuWorkspace } from "types/generated";

const StackWorkspacesActionsCell = ({
  item: workspace,
  ...cellProps
}: TableSimpleCellProps<TofuWorkspace>) => {
  const { reportSuccess, reportError } = useTypedContext(FlashContext);
  const { unlockWorkspace, loading } = useUnlockTofuWorkspace();

  const handleUnlock = async () => {
    const success = await unlockWorkspace(workspace.id);

    if (success) {
      reportSuccess({ message: `Workspace "${workspace.name}" unlocked successfully` });
    } else {
      reportError({ message: `Failed to unlock workspace "${workspace.name}"` });
    }
  };

  if (!workspace.isLocked) {
    return <TableSimpleCell {...cellProps} />;
  }

  return (
    <TableSimpleCell {...cellProps}>
      <Button variant="secondary" size="small" onPress={handleUnlock} loading={loading}>
        Unlock
      </Button>
    </TableSimpleCell>
  );
};

export default StackWorkspacesActionsCell;
